import React from "react"
import propTypes from "prop-types"

const Description = ({ children }) => {
  return <div className="form_description">{children}</div>
}

Description.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Description
